import { ReactElement } from 'react';
import Link from 'next/link';

import * as paths from 'lib/constants/paths';
import Button from 'components/atoms/button';
import { PropsWithChildren } from 'lib/@types';

export const UnauthenticatedShowInterestButton = ({
  ...props
}: PropsWithChildren): ReactElement => {
  const text = 'Acessar perfil para demonstrar interesse!';

  return (
    <Link href={paths.CANDIDATE_SIGN_IN} passHref>
      <Button aria-label={text} {...props}>
        {text}
      </Button>
    </Link>
  );
};
